<template>
  <div style="display: none;">
    <p class="text-3xl font-light mb-1">
      Team Details
      <img
        v-if="loading"
        src="/assets/images/site/loader.gif"
        class="inline-block w-6 ml-4 -mt-1"
      />
    </p>
    <p class="sub-title mb-5">
      The information you enter here will appear on your subscription invoices.
    </p>

    <form class="text-left" @submit.prevent="updateMyTeam(team)">
      <ul
        class="team-details"
        v-bind:style="{ 'pointer-events': loading ? 'none' : 'auto' }"
      >
        <Message
          v-if="errorMessage || saved"
          :message="saved ? 'Your team details have been updated successfully.' : errorMessage"
          :level="saved ? 'success' : 'error'"
          class="mb-5"
        />

        <li class="text-ma-black-1" v-bind:class="{ 'opacity-50': loading }">
          <label for="billing-email" class="uppercase font-bold mb-1">
            Billing email
          </label>
          <input
            v-model="team.billing_email"
            id="billing-email"
            name="billing-email"
            type="text"
            class="p-2"
            v-bind:class="hasError('billing_email') ? 'mb-1' : 'mb-3'"
            @input="reset"
          />
          <div
            v-if="hasError('billing_email')"
            class="text-ma-red-1 text-base mb-3"
          >
            {{ hasError("billing_email") }}
          </div>
        </li>
        <li
          class="text-ma-black-1 sm:flex"
          v-bind:class="{ 'opacity-50': loading }"
        >
          <div class="sm:w-1/2 sm:pr-2">
            <label for="first-name" class="uppercase font-bold mb-1">
              First Name
            </label>
            <input
              v-model="team.billing_first_name"
              id="first-name"
              type="text"
              name="first-name"
              class="p-2"
              v-bind:class="hasError('billing_first_name') ? 'mb-1' : 'mb-3'"
              @input="reset"
            />
            <div
              v-if="hasError('billing_first_name')"
              class="text-ma-red-1 text-base mb-3"
            >
              {{ hasError("billing_first_name") }}
            </div>
          </div>
          <div class="sm:w-1/2 sm:pl-2">
            <label for="last-name" class="uppercase font-bold mb-1">
              Last Name
            </label>
            <input
              v-model="team.billing_last_name"
              id="last-name"
              type="text"
              name="last-name"
              class="p-2"
              v-bind:class="hasError('billing_last_name') ? 'mb-1' : 'mb-3'"
              @input="reset"
            />
            <div
              v-if="hasError('billing_last_name')"
              class="text-ma-red-1 text-base mb-3"
            >
              {{ hasError("billing_last_name") }}
            </div>
          </div>
        </li>
        <li
          class="text-ma-black-1 sm:flex"
          v-bind:class="{ 'opacity-50': loading }"
        >
          <div class="sm:w-1/2 sm:pr-2">
            <label for="company-name" class="uppercase font-bold mb-1">
              Company name
            </label>
            <input
              v-model="team.company_name"
              id="company-name"
              type="text"
              name="company-name"
              class="p-2"
              v-bind:class="hasError('company_name') ? 'mb-1' : 'mb-3'"
              @input="reset"
            />
            <div
              v-if="hasError('company_name')"
              class="text-ma-red-1 text-base mb-3"
            >
              {{ hasError("company_name") }}
            </div>
          </div>
          <div class="sm:w-1/2 sm:pl-2">
            <label for="phone-number" class="uppercase font-bold mb-1">
              Phone number
            </label>
            <input
              v-model="team.phone_number"
              id="phone-number"
              type="text"
              name="phone-number"
              class="p-2"
              v-bind:class="hasError('phone_number') ? 'mb-1' : 'mb-3'"
              @input="reset"
            />
            <div
              v-if="hasError('phone_number')"
              class="text-ma-red-1 text-base mb-3"
            >
              {{ hasError("phone_number") }}
            </div>
          </div>
        </li>
        <li
          class="text-ma-black-1 flex"
          v-bind:class="{ 'opacity-50': loading }"
        >
          <div class="w-3/4 pr-2">
            <label for="address" class="uppercase font-bold mb-1">
              Address
            </label>
            <input
              v-model="team.address"
              id="address"
              type="text"
              name="address"
              class="p-2"
              v-bind:class="hasError('address') ? 'mb-1' : 'mb-3'"
              @input="reset"
            />
            <div
              v-if="hasError('address')"
              class="text-ma-red-1 text-base mb-3"
            >
              {{ hasError("address") }}
            </div>
          </div>
          <div class="w-1/4 pl-2">
            <label for="tax-id" class="uppercase font-bold mb-1">
              Tax id
            </label>
            <input
              v-model="team.tax_id"
              id="tax-id"
              type="text"
              name="tax-id"
              class="p-2"
              v-bind:class="hasError('tax_id') ? 'mb-1' : 'mb-3'"
              @input="reset"
            />
            <div v-if="hasError('tax_id')" class="text-ma-red-1 text-base mb-3">
              {{ hasError("tax_id") }}
            </div>
          </div>
        </li>
        <li
          class="text-ma-black-1 sm:flex"
          v-bind:class="{ 'opacity-50': loading }"
        >
          <div class="sm:w-1/2 sm:pr-2 city-wrap">
            <label for="city" class="uppercase font-bold mb-1">
              City
            </label>
            <input
              v-model="team.city"
              id="city"
              type="text"
              name="city"
              class="p-2"
              v-bind:class="hasError('city') ? 'mb-1' : 'mb-3'"
              @input="reset"
            />
            <div v-if="hasError('city')" class="text-ma-red-1 text-base mb-3">
              {{ hasError("city") }}
            </div>
          </div>
          <div class="sm:w-1/2 sm:pl-2 flex">
            <div class="w-1/2 pr-3">
              <label for="state" class="uppercase font-bold mb-1">
                state
              </label>
              <input
                v-model="team.state"
                id="state"
                type="text"
                name="state"
                class="p-2"
                v-bind:class="hasError('state') ? 'mb-1' : 'mb-3'"
                @input="reset"
              />
              <div
                v-if="hasError('state')"
                class="text-ma-red-1 text-base mb-3"
              >
                {{ hasError("state") }}
              </div>
            </div>
            <div class="w-1/2 pl-1">
              <label for="postal-code" class="uppercase font-bold mb-1">
                Postal Code
              </label>
              <input
                v-model="team.postal_code"
                id="postal-code"
                type="text"
                name="postal-code"
                class="p-2"
                v-bind:class="hasError('postal_code') ? 'mb-1' : 'mb-3'"
                @input="reset"
              />
              <div
                v-if="hasError('postal_code')"
                class="text-ma-red-1 text-base mb-3"
              >
                {{ hasError("postal_code") }}
              </div>
            </div>
          </div>
        </li>
        <li class="text-ma-black-1" v-bind:class="{ 'opacity-50': loading }">
          <label for="country" class="uppercase font-bold mb-1">
            Country
          </label>
          <v-select
            label="name"
            :options="countryList"
            :reduce="(country) => country.id"
            :placeholder="'Select a Country'"
            :clearable="false"
            v-model="team.country_id"
            class="country-list bg-white italic text-lg"
            v-bind:class="hasError('country_id') ? 'mb-1' : 'mb-6'"
          ></v-select>
          <div
            v-if="hasError('country_id')"
            class="text-ma-red-1 text-base mb-6"
          >
            {{ hasError("country_id") }}
          </div>
        </li>
        <li class="sm:text-left text-center">
          <button
            type="submit"
            class="font-bold w-40 p-2 text-base text-white btn btn--primary"
            v-bind:class="loading ? 'pointer-events-none' : ''"
            :disabled="loading || saved"
          >
            <div
              class="animation-spin btn-spinner inline-block mr-2"
              v-show="loading"
              v-cloak
            >
              <i class="icon--spinner2"></i>
            </div>
            Save Changes
          </button>
        </li>
      </ul>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Message from "@/components/Message";

export default {
  components: {
    vSelect,
    Message,
  },
  computed: {
    ...mapGetters({
      team: "teamDetails/team",
      countryList: "teamDetails/countryList",
      loading: "teamDetails/loading",
      saved: "teamDetails/saved",
      errorMessage: "teamDetails/errorMessage",
      hasError: "teamDetails/hasError",
    }),
  },
  methods: {
    ...mapActions({
      getMyTeam: "teamDetails/getMyTeam",
      updateMyTeam: "teamDetails/updateMyTeam",
      getCountryList: "teamDetails/getCountryList",
      resetSaved: "teamDetails/resetSaved",
      clearError: "teamDetails/clearError",
    }),
    reset() {
      this.clearError();
      this.resetSaved();
    }
  },
  mounted() {
    document.querySelector('.account-links__container').parentElement.appendChild(this.$el)
    this.$el.style.display = null
    this.getCountryList();
    this.getMyTeam();
  },
  metaInfo: () => ({
    title: "Team Details | Motion Array",
  }),
};
</script>

<style>
.team-details {
  display: flex;
  flex-flow: column;
  max-width: 670px;

  label {
    font-size: 13px;
  }
  input {
    height: 44px;
  }
  .sub-title {
    font-size: 18px;
    font-weight: normal;
  }
  .city-wrap {
    height: 85px;
  }
  .country-list {
    font-size: 18px;

    .vs__dropdown-toggle {
      border-radius: 0;
      padding: 3px 0 8px 10px;

      input {
        height: unset;
      }
    }

    .vs__dropdown-menu {
      .vs__dropdown-option--highlight {
        background: #67c7d8;
      }
    }
  }
}
</style>
